export default "__VITE_ASSET__D2tBm$k1__"